export default [
  {
    path: '/ListRequest',
    name: 'Lista de Solicitações',
    page: 'ListRequest',
    authRequired: true
  },
  {
    path: '/Request',
    name: 'Solicitação',
    page: 'Request',
    authRequired: true
  },
  {
    path: '/Profile',
    name: 'Alterar Senha',
    page: 'Profile',
    authRequired: false
  },
  {
    path: '/ResetPasswordMail',
    name: 'Esqueci a Senha',
    page: 'ResetPasswordMail',
    authRequired: false
  },
  {
    path: '/ChangePasswordMail',
    name: 'Alterar a Senha',
    page: 'ChangePasswordMail',
    authRequired: false
  },
  {
    path: '/login',
    name: 'Login',
    page: 'login'
  },
  {
    path: '/detail',
    name: 'Detalhes da Solicitação',
    page: 'RequestDetail',
    authRequired: true
  },
  {
    path: '/printrequest',
    name: 'Imprimir Solicitação',
    page: 'RequestDetailPrint',
    authRequired: true
  },
  {
    path: '/',
    name: 'Formulário Eletrônico - PRODAM',
    page: 'Home',
    authRequired: true
  },
  //! This statement should be placed at the end.
  {
  path: '*',
    name: 'Page Not Found',
    page: 'errors/404'
  }
]